import React, { useEffect, useRef } from 'react';

// A mirrored live view of the station webcam (people expect a mirror). The pictures sent to
// /face/identify are taken from the stream itself, never mirrored.
export default function FacePreview({ stream, width = 200, testId = 'face-preview', style }) {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return undefined;
    try { v.srcObject = stream || null; } catch (e) { /* old browser */ }
    return () => {
      try { v.srcObject = null; } catch (e) { /* gone */ }
    };
  }, [stream]);

  return (
    <video
      ref={ref}
      data-testid={testId}
      autoPlay
      muted
      playsInline
      aria-label="Camera view"
      style={{
        width,
        maxWidth: '100%',
        aspectRatio: '16 / 9',
        objectFit: 'cover',
        transform: 'scaleX(-1)',
        background: '#111',
        borderRadius: 6,
        display: 'block',
        ...style,
      }}
    />
  );
}
